import whatsapp_icon from "../../Img/Android_Enterprise_image/whatsapp_icon.png";
import mail_icon from "../../Img/Android_Enterprise_image/mail_icon.png";
import androad_banner from "../../Img/Android_Enterprise_image/androad_banner.png";
import android_Business_side_image from "../../Img/Android_Enterprise_image/android_Business_side_image.jpg";
import stay_secure from "../../Img/Android_Enterprise_image/stay_secure.svg";
import drive_business from "../../Img/Android_Enterprise_image/drive_business.svg";
import everyday_productive from "../../Img/Android_Enterprise_image/everyday_productive.svg";
import security from "../../Img/Android_Enterprise_image/security.png";
import security_2 from "../../Img/Android_Enterprise_image/security_2.png";
import security_3 from "../../Img/Android_Enterprise_image/security_3.png";
import google_verified from "../../Img/Android_Enterprise_image/google_verified.png";
import AndroidEnterpriseEbook from '../../Img/mdm_pdf/Android-Enterprise-eBook.pdf';
import PartnerLostModeOnePager from '../../Img/mdm_pdf/PARTNER-Lost-mode-one-pager.pdf';
import AndroidManagementOnePagerPARTNER from '../../Img/mdm_pdf/Android-Management-One-Pager-PARTNER.pdf';
import WorkProfileOnePagerPARTNER from '../../Img/mdm_pdf/Work-Profile-One-Pager-PARTNER.pdf';
import { Link } from "react-router-dom";
import "./Android_Enterprise.css";
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer';
const Android_Enterprise = () => {
  return (
    <>
     <Navbar></Navbar>
     <section className="default-section header-banner">
      <div className="container pt-xl-5">
        <div className="row align-items-md-center g-4">
          <div className="col-12 col-md-12  col-lg-6">
            <div className="content-block mb-4 mb-md-0">
              <h2 className="sub-title mb-4 pb-lg-2">
                Unlock Exclusive Enterprise Offers on Android Devices
              </h2>
              <div className="detail mb-4 mb-lg-5 pr-0 pr-xs-5">
                <p>
                  Save big on every Android devices &amp; empower your
                  workforce.
                </p>
              </div>
              <div className="dropdown-str">
                <a
                  className="dropbtn-str"
                  href="/ContactUs"
                  target="_blank"
                >
                  Contact Us
                </a>
              </div>
              <div className="detail mb-4 mb-lg-5 pr-0 pr-xs-5 mt-4">
                <p style={{ fontSize: "15px" }} >
                  <sup>*</sup>T &amp; C Apply
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-12  col-lg-6">
            <div className="img-block">
              <img style={{ width: "410px" }} src={androad_banner} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
{/* ------------------------------------------------------------------------ */}
<section class="default-section header-banner-section mt-5">
    <div class="container pt-xl-5">
        <div class="row align-items-md-center g-4">

            <div class="col-md-12 col-lg-6">
                <div class="content-block mb-4 mb-md-0">
                    <h1 class="title mb-4">Android <br/>Built for Business</h1>
                    <h2 class="sub-title mb-4 pb-lg-2">Mobility for every worker and every use case</h2>
                    <div class="detail mb-4 mb-lg-5 pr-0 pr-xs-5">
                        <p>
                            Whatever your business is, Android™, can help make it possible. There are Android devices
                            for any job. Enterprise-grade security to protect data. More ways to create custom apps. And
                            Google™ innovation powering it all.
                        </p>
                    </div>
                   <div className="first-two" style={{ display: "flex" }}>

                        <div class="bottom-btn mb-5 mb-md-0" style={{ display: "flex", margin :"0px 30px 0px 0px" }}>
                                <a class="btn btn-primary pl-4 pr-4 pl-sm-5 pr-sm-5" href="/ContactUs" target="_blank">Enquire
                                Now</a>
                        </div>
                        <div class="bottom-btn mb-5 mb-md-0">
                            <a   href={AndroidEnterpriseEbook} target="_blank" class="btn btn-primary pl-4 pr-4 pl-sm-5 pr-sm-5">
                                Download
                                ebook
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-lg-6">
                <div class="image_box">
                    <div class="img-block">
                         <img src={android_Business_side_image} alt="" />
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
{/* --------------------------------------------------------------------------- */}
<section class="default-section three-block-section mt-5">
    <div class="container">
        <div class="inner-div">
            <div class="row g-4">
                <div class="column col-12 col-sm-12 col-md-6 col-lg-4 ">
                    <div class="icon-content-block">
                        <div class="icon-div mb-4">
                             <img src={stay_secure} alt="" className="img-fluid" />
                        </div>
                        <h4 class="title">Stay secure and in control.</h4>
                        <div class="detail-div">
                            <p>Android has multi-layered defenses to protect your business and employee data.</p>
                        </div>
                    </div>
                </div>

                <div class="column col-12 col-sm-12 col-md-6 col-lg-4">
                    <div class="icon-content-block">
                        <div class="icon-div mb-4"> 
                             <img src={drive_business} alt="" className="img-fluid" />
                        </div>
                        <h4 class="title">Drive business forward.</h4>
                        <div class="detail-div">
                            <p>Lots of devices to choose from. Flexible management features. Set Android up for the way
                                your company works best.</p>
                        </div>
                    </div>
                </div>

                <div class="column col-12 col-sm-12 col-md-6 col-lg-4">
                    <div class="icon-content-block mb-0">
                        <div class="icon-div mb-4">
                            <img src={everyday_productive} alt="" className="img-fluid" />
                        </div>
                        <h4 class="title">Make everyday productive.</h4>
                        <div class="detail-div">
                            <p>Android helps employees get more done using smart Google tools. With the security and
                                privacy they need.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
{/* ------------------------------------------------------------------------- */}
<section class="section">
    <div class="container">
        <div class="row align-items-center g-4">

            {/* <!-- Left Image --> */}
            <div class="col-12 col-md-12 col-lg-6 mb-4 mb-md-0">
                <div class="image-box">
                     <img src={security} alt="" className="img-fluid" />
                </div>
            </div>

            {/* <!-- Right Content --> */}
            <div class="col-12 col-md-12 col-lg-6 content">
                <h2>Protect data<br /> from end to end.</h2>
                <p>Android security is built in layers. From the hardware to the operating system to security services
                    like Google Play Protect. Each layer works together to help prevent leaks and phishing, block
                    malware and make sure data isn’t lost. So your business can stay ahead of threats.</p>
                <a href={PartnerLostModeOnePager} target="_blank" class="btn btn-sm btn-secondary ms-2 Learn_More">
                    One-Pager
                </a>
                <br />
                <br />
                <br />
                <div class="side-content-block">
                    <h2 class="title">Deploy and manage your <br />mobile fleet. On your terms.</h2>
                    <div class="pr-xl-5 mr-xl-5">
                        <p>Android gives your business tons of flexibility to manage devices. Set oversight levels from
                            locked down to limited. Distribute apps through managed Google Play—including your company’s
                            private apps. With deployment options that work for you.</p>
                    </div>
                    <a href={AndroidManagementOnePagerPARTNER} target="_blank" class="btn btn-sm btn-secondary ms-2 Learn_More">
                        One-Pager
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
{/* ---------------------------------------------------- */}
<section class="section">
    <div class="container">
        <div class="row align-items-center  g-4">

             {/* Left Image  */}
            <div class="col-12 col-md-12 col-lg-6 mb-md-0 left_part">
                <div class="image-box">
                     <img src={security_2} alt="" className="img-fluid" />
                </div>
            </div>

             {/* Right Content  */}
            <div class="col-12 col-md-12 col-lg-6 content">
                <h2>Zero-touch. Zero hassle.</h2>
                <p>With zero-touch enrollment, IT teams can instantly deploy fleets of company-owned devices. And
                    they’re all secured out of the box. Employees just power on to get started. The apps and
                    configurations they depend on are ready to go.</p>
                      <Link to="/Zero_touch_section" className="btn btn-sm btn-secondary ms-2 Learn_More" >  Learn More  </Link>  
                   
                <br />
                <br />
                <br />
                <div class="side-content-block">
                    <h2 class="title">Help employees get more done.</h2>
                    <div class="pr-xl-5 mr-xl-5">
                        <p>It’s easy for employees to use their Android devices at work. Just use the work profile to
                            keep personal data separate. Collaborate flexibly with smart Google tools like Meet, Drive
                            and Docs. And disconnect when the workday is done with Digital Wellbeing tools.</p>
                    </div>
                    <a href={WorkProfileOnePagerPARTNER} target="_blank" class="btn btn-sm btn-secondary ms-2 Learn_More">
                        One-Pager
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
{/* -------------------------------------------------------- */}
<section class="section">
    <div class="container">
        <div class="row align-items-center  g-4">

             {/* Left: Image  */}
            <div class="col-12 col-md-12 col-lg-6 text-center mb-4 mb-md-0">
                  <img src={security_3} alt="" className="img-fluid" />
            </div>

             {/* Right: Text Content  */}
            <div class="col-12 col-md-12 col-lg-6">
                <div class="text-box">
                    <h2>Devices for <br/>every business.</h2>
                    <p>There’s an Android device for every industry. Like tablets that keep retail spaces running.
                        Scanners to transform warehouse shipping. And with Android Enterprise Recommended, get
                        verified devices that meet Google’s highest standards.</p>
                </div>

                {/* Highlight Card  */}
                <div class="card-highlight align-items-start">
                    <a href="https://www.android.com/enterprise/recommended/" target="blank"> 
                      <img src={google_verified} alt="" className="img-fluid"  style={{width: "160px"}} />
                    </a>
                    <div>
                        <h5>Look for Google verified devices.</h5>
                        <p>Find devices that meet Google’s strict hardware and software requirements. That means you get
                            consistent mobile management, timely security updates and guaranteed release upgrades.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
{/* ------------------------------------------------ */}
<section>
    <div class="container py-5">
        <div class="text-center mb-5">
            <h2 class="fw-bold">Why Harsafe as Your Android Partner?</h2>
        </div>

        <div class="row g-4">
             {/* Card 1  */}
            <div class="col-md-4">
                <div class="company-card">
                    <div class="company-icon bg-primary">
                        <i class="bi bi-bar-chart"></i>
                    </div>
                    <h6 class="fw-bold">Expert Support and Management</h6>
                    <p class="text-muted text-truncate-3">
                        From device setup to ongoing management, mdm ensures your Android devices are fully
                        optimized and securely integrated into your ecosystem.
                    </p>
                </div>
            </div>

             {/* Card 2  */}
            <div class="col-md-4">
                <div class="company-card">
                    <div class="company-icon bg-secondary">
                       <i class="bi bi-water"></i>
                    </div>
                    <h6 class="fw-bold">Tailored Solutions for Every Enterprise</h6>
                    <p class="text-muted text-truncate-3">
                        Whether your business is scaling or evolving, mdm offers Android solutions tailored to your
                        specific needs, helping you stay ahead in a fast-paced world.
                    </p>
                </div>
            </div>

             {/* Card 3 */}
            <div class="col-md-4">
                <div class="company-card">
                    <div class="company-icon bg-warning text-dark">
                        <i class="bi bi-bullseye"></i>
                    </div>
                    <h6 class="fw-bold ">Commitment to Excellence.</h6>
                    <p class="text-muted text-truncate-3">
                        With over a decade of experience in IT solutions, mdm provides unparalleled service,
                        ensuring your Android deployment is seamless and impactful.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<Footer></Footer>
    </>
  );
};

export default Android_Enterprise;
